import init, { aes_encrypt, aes_decrypt } from "@/wasm/rust_wasm.js";
import axios from "axios";
import type { AxiosResponse } from "axios";
import type { ApiResult } from "@/api";
import { Modal } from "ant-design-vue";

const instance = axios.create({
  transformRequest: function transformRequest(data, headers) {
    const hasJSONContentType = () => {
      const contentType: any = (headers && headers["Content-Type"]) || "";
      return contentType.indexOf("application/json") > -1;
    };
    if (typeof data === "string" && hasJSONContentType()) {
      return data;
    }
    (axios.defaults.transformRequest as any)?.forEach((tr: any) =>
      tr(data, headers)
    );
  },
  baseURL: process.env.VUE_APP_BASE_API,
});
instance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res: AxiosResponse<ApiResult<unknown>>) => {
    if (res.data?.code === "0") {
      Modal.destroyAll();
      Modal.error({
        title: "提示",
        content: res.data.msg,
        okText: "确定",
      });
      return Promise.reject(new Error(res.data.msg));
    }
    const data: any = JSON.parse(aes_decrypt(res.data as any));
    if (data.code === "101") {
      Modal.destroyAll();
      Modal.info({
        title: "系统提示",
        content: "登录状态已过期，请退出重新登录！",
        okText: "重新登录",
        onOk: () => {
          // logout(currentPath);
        },
      });
      return Promise.reject(new Error(data.msg));
    }
    return { ...res, data: data };
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default async function request<T>(
  url: string,
  type: string,
  data?: object
) {
  await init();
  let encryptData: any = data;
  if (data) {
    encryptData = aes_encrypt(JSON.stringify(encryptData));
  }
  if (type === "GET") {
    return instance.get<ApiResult<T>>(url, {
      params: data ? encryptData : undefined,
      headers: {
        "Content-Type": "application/json;charset=UTF-8", // 必须设置此请求头:ml-citation{ref="6,9" data="citationList"}
      },
    });
  } else {
    return instance({
      url: url,
      method: "post",
      headers: { "Content-Type": "application/json;charset=utf-8" },
      data: data ? encryptData : null,
    });
  }
}
